export const AUTH_TOKEN_NAME = 'authToken'
export const REFRESH_TOKEN_NAME = 'refreshToken'
export const ACCOUNT_ID_NAME = 'accountId'
export const DEFAULT_PAGE_SIZE = 50
export const MAX_PAGE_SIZE = 500
export const DEFAULT_PAGE_SIZE_KEY = 'defaultPageSize'
export const BI_TOKEN_NAME = 'biToken'
export const BI_DASHBOARDS = 'dashboards'
export const BI_DASHBOARD_URL = 'dashboardUrl'
export const isInsightsEnabled = (): boolean => true
export const ROUTER_BASEPATH = '/dashboard'
